import { useCallback } from "react";
import axiosInstance from "../../service/axiosInstance";
import { multiCurrencyAPI } from "../../service/api";
import { ISO_DATE_FORMAT, POST } from "../constants";
import { formatDate } from "../helper";
import { IRate } from "../../interfaces/multiCurrencyInterface";

const useExchangeRates = () => {
  const getRatesByToCurrencyIds = useCallback(async (borrowerId: number, fromCurrencyId: number, asOfDate: string, toCurrencyIds: number[]) => {
    try {
      const response = await axiosInstance.request({
        url: multiCurrencyAPI.GET_ALL_RATES_BY_TO_CURRENCY_IDS,
        method: POST,
        params: { borrowerId, fromCurrencyId, asOfDate: formatDate(asOfDate, ISO_DATE_FORMAT) },
        data: toCurrencyIds
      });
      return response.data.content as IRate[];
    } catch (error) {
      console.log('GET RATES BY TO CURRENCY IDS ERROR: ', error);
      return [];
    }
  }, []);

  const convertAmountByRate = useCallback((amount: number, rate: number) => {
    // current implementation of rates should be divided to get the desired output
    return amount / rate;
  }, [])

  const getRates = useCallback(async (
    borrowerId: number,
    borrowerCurrencyId: number,
    bbPeriod: string,
    collateralCurrencyIds: number[],
    selectedCollateralCurrencyId: number
  ) => {
    const rates = await getRatesByToCurrencyIds(borrowerId, borrowerCurrencyId, bbPeriod, collateralCurrencyIds);

    const defaultRate: IRate = {
      recordId: 0,
      asOfDate: bbPeriod,
      currencyRate: 1,
      userName: '',
      borrowerId: borrowerId,
      fromCurrencyId: selectedCollateralCurrencyId,
      toCurrencyId: selectedCollateralCurrencyId
    };

    return [...rates, defaultRate];
  }, [])

  const checkCollateralRate = useCallback((selectedCollateralCurrencyId: number, selectedCurrencyId: number, rates: IRate[]) => {
    if (selectedCollateralCurrencyId === selectedCurrencyId) {
      const defaultRate = rates.find(rate => rate.recordId === 0);
      const selectedRate = defaultRate ?? null
      return selectedRate;
    } else {
      const collateralRate = rates.find(rate =>
        rate.toCurrencyId === selectedCollateralCurrencyId &&
        rate.fromCurrencyId === selectedCurrencyId
      );
      
      if (collateralRate) {
        return collateralRate;
      } else {
        return null;
      }
    }
  }, [])

  return {
    getRatesByToCurrencyIds,
    convertAmountByRate,
    getRates,
    checkCollateralRate,
  };
};

export default useExchangeRates;
